// extracted by mini-css-extract-plugin
export default {"CandidateCardInfo__list":"P51_U","CandidateCardInfo__listItem":"WCBbZ","CandidateCardInfo__listItemIcon":"L0aT6","CandidateCardInfo__summary":"XS_ul"};